import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/36/thumb-landscape.jpg"

const Post36 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">LOEWE／ゲートトップハンドルミニ／25 x18 x9cm</span>  
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>ロエベは、海外セレブをはじめ、国内の芸能人やモデルなども愛用している人気ブランド。<br />スペイン発のブランドで、レザー製品に定評があります。歴史に裏打ちされた確かな品質と特徴的なデザインが多くの方を虜に。<br />そんなロエベの最旬バッグをご紹介！どれも国内外のドラマやセレブの愛用バッグとして登場するものばかり。見つけたら、即予約がおすすめです。</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>Balloon／バルーン</h2>
          <p>ロエベのNEXTバッグと噂されている「バルーン」は丸い風船のようなフォルム。異なる素材や色の組み合わせで、さまざまなバリエーションが発表されています。</p>
        </div>
        <figure>
          <StaticImage src="../../images/posts/36/1.jpg" alt="" />
          <span className="text-center">LOEWE／バルーンバッグスモール／18 x25 x13cm</span>  
          <span className="text-center">2種類のレザーの組み合わせ</span>
        </figure>
        <figure>
          <StaticImage src="../../images/posts/36/2.jpg" alt="" />
          <span className="text-center">こちらのボディはシボ感のある柔らかいレザー</span>
        </figure>
        <p>手にとって、まず思ったのが「えっ？軽い…」（※個人の感想です）<br />レザーの質感がしっかりしていたので、ズッシリ重そうだと予想していたのに嬉しい裏切り！間口も大きく開き、使いやすそうなバッグです。</p>
        <figure>
            <StaticImage src="../../images/posts/36/3.jpg" alt="" />
            <span className="text-center">LOEWE／バルーンバッグスモール／18 x25 x13cm</span>  
            <span className="text-center">艶のあるスムースレザーはクリーンなイメージ</span>
        </figure>          
        <figure>
            <StaticImage src="../../images/posts/36/4.jpg" alt="" />
            <span className="text-center">バッグの底にもブランドロゴ</span>
        </figure>
        <Link to="https://laxus.co/app/pc/bags/loewe" className="view-all-button">
          ロエベのバッグを見る
        </Link>        
        <div className="text-max-width">
          <h2>Hammock／ハンモック</h2>
          <p>言わずと知れたロエベの大人気バッグといえば、こちら「ハンモック」。変幻自在に形を変えて、持つ人の身体や使用したいシーンに自然に馴染んでいきます。定番サイズもいいですが、ミニサイズも新鮮です。お財布とスマホ、リップだけで身軽にお出かけなんていかがでしょう？</p>
        </div>
        <figure>
          <StaticImage src="../../images/posts/36/5.jpg" alt="" />
          <span className="text-center">
            左から<br></br>
            LOEWE／ハンモックドローストリングミニ／14 x18 x11cm<br></br>
            LOEWE／ハンモック／34 x31 x17cm
          </span>  
          <span className="text-center">色やサイズ展開が豊富</span>
        </figure>
        <figure>
          <StaticImage src="../../images/posts/36/6.jpg" alt="" />
          <span className="text-center">LOEWE／ハンモックドローストリングミニ／15 x18 x11cm</span>  
          <span className="text-center">ミニの色違い。このサイズにサイドジップはなし</span>
        </figure>
        <figure>
        <StaticImage src="../../images/posts/36/7.jpg" alt="" />
          <span className="text-center">中には小さなポケット付き</span>
        </figure>             
        <div className="text-max-width">
          <h2>Gate／ゲート</h2>
          <p>クラシカルな乗馬の鞍のシルエットをロエベ独自の解釈でアップデートされたデザイン。フロント部分で結ばれたリボンのようなベルトが特徴です。ショルダータイプからトップハンドル、ベーシックカラー、単色、異素材の組み合わせ、複数のサイズ展開など、バリエーション豊富。</p>
        </div>    
        <figure>
          <StaticImage src="../../images/posts/36/8.jpg" alt="" />
          <span className="text-center">LOEWE／ゲートトップハンドルミニ／25 x18 x9cm</span>  
        </figure>
        <p>こちらのショルダータイプは、人気の韓国ドラマで出演者が使用したことで話題に。</p>
        <figure>
          <StaticImage src="../../images/posts/36/9.jpg" alt="" />
          <span className="text-center">LOEWE／ゲートバッグスモール／27 x20 x12cm</span>  
        </figure> 
        <figure>
          <StaticImage src="../../images/posts/36/10.jpg" alt="" />
          <span className="text-center">仕切りがあるから持ち物を整理しやすい</span>
        </figure>
        <p>ゲートシリーズはしっかりとした作りで、型崩れなどは少なそう。反面、間口の開きも固めです。</p>
        <div className="text-max-width">
          <h2>Puzzle／パズル</h2>
          <p>レザーのパーツをパズルのように組み合わせたユニークなフォルムが特徴。ショルダーやハンドも含め5WAYで使える利便性と、コンサバすぎないシンプルなデザインに支持が集まっています。</p>
        </div>
        <figure>
          <StaticImage src="../../images/posts/36/11.jpg" alt="" />
          <span className="text-center">LOEWE／パズルバッグ／28 x18 x12cm</span>  
        </figure>
        <figure>
          <StaticImage src="../../images/posts/36/12.jpg" alt="" />
          <span className="text-center">控えめなブランドロゴが好印象</span>
        </figure>
        <figure>
          <StaticImage src="../../images/posts/36/13.jpg" alt="" />
          <span className="text-center">背面にはジップポケット</span>
        </figure>
        <p>柔らかい手触りや見た目以上の収納力といった、使ってみて分かる良さに魅了される方が続出！リピート率の高いシリーズです。</p>        
        <div className="text-max-width">
          <h2>Cushion tote／クッショントート</h2>
          <p>カチッとした作りなのにクッショントート？と不思議でしたが、ロエベで過去に作られていた製品であるレザーの大きな室内用クッションにインスパイアされ生まれたそう。オールレザーやキャンバス、フェルトなどボディの素材もさまざまです。</p>          
        </div>      
        <figure>
          <StaticImage src="../../images/posts/36/14.jpg" alt="" />
          <span className="text-center">LOEWE／クッショントート／32 x24 x14cm</span>  
        </figure>
        <figure>
          <StaticImage src="../../images/posts/36/15.jpg" alt="" />
          <span className="text-center">マチもたっぷり</span>
        </figure> 
        <p>自立型で大きく開く間口のため、荷物の出し入れも楽ちん。</p>           
        <figure>
          <StaticImage src="../../images/posts/36/16.jpg" alt="" />
          <span className="text-center">間仕切りはなくシンプル構造</span>
        </figure>      
        <p>PCを持ち歩くことが増えてきたこともあって、クッショントートのようなシンプルで大き目のバッグに人気が集まっています。</p>
        <div className="text-two-cloumn">
          <h2>もし貸出中だったら？</h2>
          <p>ラクサスでは常にバッグを仕入れていますが、人気のバッグは公開後すぐに「貸出中」になることも珍しくありません。使ってみたいバッグを見つけたら例え貸し出し中でも、お気に入りに登録するのがおすすめです。返却されるとプッシュでお知らせ通知が、受け取れるのでチャンスを逃しません。ぜひ、活用してみてください！</p>
        </div>                                                
        <Link to="https://laxus.co/app/pc/bags/loewe" className="view-all-button">
          ロエベのバッグを見る
        </Link>                
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post36

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 36}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
